module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid-100 grid-parent",
    class: ("grid-100 grid-parent " + (this.classes))
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "about-horizontal-wrapper layer1"
  }, [_c('div', {
    ref: "slider",
    staticClass: "about-horizontal-list"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "about-item",
      class: {
        small: (item.small_image == '1')
      }
    }, [_c('div', {
      staticClass: "about-img",
      style: ({
        backgroundImage: 'url(' + item.background_image.guid + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "about-copy",
      class: {
        white: (item.text_color == 'white')
      }
    }, [_c('h4', {
      staticClass: "title",
      domProps: {
        "innerHTML": _vm._s(item.title.rendered)
      }
    }), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(item.content.rendered)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "line-info"
    }, [_c('span', {
      staticClass: "year",
      class: {
        white: (item.text_color == 'white'), black: (item.text_color == 'black')
      }
    }, [_vm._v(_vm._s(item.about_date))]), _vm._v(" "), (item.link_text) ? _c('a', {
      staticClass: "cta"
    }, [_c('span', [_vm._v(_vm._s(item.link_text))])]) : _vm._e()])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "arrows-bar grid-100 grid-parent"
  }, [_c('img', {
    staticClass: "arrow-left",
    attrs: {
      "src": require("../assets/images/arrow-left.png")
    },
    on: {
      "click": function($event) {
        return _vm.timelineLeft()
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "arrow-right",
    attrs: {
      "src": require("../assets/images/arrow-right.png")
    },
    on: {
      "click": function($event) {
        return _vm.timelineRight()
      }
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cdb0c92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Carousel.vue
// module id = 278
// module chunks = 0